import { Cache, DataStore } from '@skinsoft/data-store';
import { Proxy } from '@skinsoft/network';

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    title: string;
    username: string;
}

export class UserDataStore extends DataStore<User> {
    public static getInstance() {
        if (!UserDataStore.instance) {
            UserDataStore.instance = new UserDataStore();
        }

        return UserDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$userDataStore = UserDataStore.getInstance();
    }

    private static instance: UserDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<User>) {
        super('/users', undefined, undefined, proxy, cache);
    }
}
